import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TeamDetail from './components/TeamDetail';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="35c28kv02tw3o">
      <div className="bg-gray-50 min-h-screen w-full" data-id="element-1" data-mp="35eobghc0vnfk">
        <div className="pt-6" data-id="element-2" data-mp="3k89rzt3nuthw">
          <Routes data-id="element-3" data-mp="3k7i3f28hdw14">
            <Route path="/" element={<TeamDetail data-id="element-5" data-mp="3fa86z2mock3s" />} data-id="element-4" data-mp="3fahwkp3t4p8y" />
            <Route path="/teams/:teamId" element={<TeamDetail data-id="element-7" data-mp="2rkx3vehuqdmh" />} data-id="element-6" data-mp="3fb14re3nnz9s" />
          </Routes>
        </div>
      </div>
    </BrowserRouter>;
}